// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".3d3cb8be437ce5842ce94242bd5adc1f10ca1cc4.chunk.bundle.js";
};